var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inline-block"},[_c('a',{staticClass:"text-black",on:{"click":function($event){return _vm.$uloc.window.close(_vm.$root.wid)}}},[_vm._v("Fechar janela ["+_vm._s(_vm.count)+"]")])])
}
var staticRenderFns = []

export { render, staticRenderFns }